import { Component, OnInit } from '@angular/core';
import { LoginService } from '../projectservice/login.service';
import { MENU_ITEMS } from './pages-menu';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu  [items]="filterArray" ></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class PagesComponent implements OnInit {
  navAgentOrDept = ['Live Calls', 'Call Logs', 'Black List', 'Click2Call', 'Click2Call Log'];
  navAdmin = ['Live Calls', 'Manage User', 'Manage Agent', 'Call Logs', 'Black List', 'Click2Call', 'Click2Call Log'];
  menu = MENU_ITEMS;
  navFlag: boolean;
  filterMenu: Array<any> = [];
  constructor(private _login: LoginService) {

  }
  ngOnInit(): void {
    this.getNavigationAccess();
  }
  filterArray: Array<any> = [];
  getNavigationAccess() {
    this.filterArray = [];
    if (this._login.getLoggedInUser().usertype == 'Agent' || this._login.getLoggedInUser().usertype == 'AGENT' || this._login.getLoggedInUser().usertype == 'dept'|| this._login.getLoggedInUser().usertype == 'DEP') {
      this.menu.forEach(d => {
        this.navAgentOrDept.forEach(nA => {
          if (d.title === nA) {
            this.filterArray.push(d);
          }
        })
      })
    }
    if (this._login.getLoggedInUser().usertype == 'ADMIN') {
      this.menu.forEach(d => {
        this.navAdmin.forEach(nA => {
          if (d.title === nA) {
            this.filterArray.push(d);
          }
        })
      })
    }
  }
}
